import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "keyboard_arrow_left",
  "use": "keyboard_arrow_left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"keyboard_arrow_left\">\n<title>keyboard_arrow_left</title>\n<path d=\"M15.422 16.594l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol